import React, { useState } from "react";
import Modal, { ModalBody, ModalFooter } from "../Modal";
import Icon from "../Icon";
import { Button, Field } from "../primitives";
import { NAME_MAX_LEN, URL_MAX_LEN, normalizeAndValidateUrl } from "../../../../utils/linkUrl";

/** Add / edit a club link (AddLinkSheet with showMembersOnly). onSubmit({ url, name, is_members_only }). */
export default function LinkModal({ initial, onSubmit, onClose, testId = "linkModal" }) {
  const [url, setUrl] = useState(initial?.url || "");
  const [name, setName] = useState(initial?.name || "");
  const [membersOnly, setMembersOnly] = useState(!!initial?.is_members_only);

  const { normalized, valid } = normalizeAndValidateUrl(url);
  const trimmedName = name.trim();
  const canSubmit = valid && trimmedName.length > 0;
  const showError = url.trim().length > 0 && !valid;

  const submit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit({ url: normalized, name: trimmedName, is_members_only: membersOnly });
  };

  return (
    <Modal title={initial ? "Edit link" : "Add link"} size="narrow" onClose={onClose} testId={testId}>
      <ModalBody as="form" id="manage-link-form" onSubmit={submit}>
        <Field
          label="URL *"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="e.g. https://instagram.com/yourclub"
          maxLength={URL_MAX_LEN}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          inputMode="url"
          data-testid={`${testId}.url`}
          error={showError ? "Enter a valid link, e.g. https://instagram.com/yourclub" : undefined}
        />
        <Field label="Name *" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Instagram" maxLength={NAME_MAX_LEN} data-testid={`${testId}.name`} />
        <button type="button" className="row" role="checkbox" aria-checked={membersOnly} onClick={() => setMembersOnly((v) => !v)} data-testid={`${testId}.membersOnly`}>
          <span className={`check ${membersOnly ? "on" : ""}`}>{membersOnly && <Icon name="check" size={14} />}</span>
          <b>Members only</b>
          <span className="meta">Only club members and leaders can see this link</span>
        </button>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose} data-testid={`${testId}.cancel`}>Cancel</Button>
        <Button type="submit" form="manage-link-form" disabled={!canSubmit} data-testid={`${testId}.save`}>Save</Button>
      </ModalFooter>
    </Modal>
  );
}
